import {eatalianoAxios} from "@/data/api/http/axios";
import {EmployeeInReport, EmployeeTimeEntry, EmployeeTimeEntryFormValues} from "@/data/entities/employee";
import {Message} from "@/data/entities/message";

export const deleteTimeEntry = (entryId: number): Promise<Message> => (
    eatalianoAxios
        .delete(`/employees/time-entries/${entryId}`)
        .then(response => response.data)
);

export const updateTimeEntry = (entryId: number, fields: EmployeeTimeEntryFormValues): Promise<EmployeeTimeEntry> => (
    eatalianoAxios
        .put(`/employees/time-entries/${entryId}`, fields)
        .then(response => response.data)
);

export const getTimeEntriesReport = (
    from: string,
    to: string,
    restaurantId: number,
): Promise<EmployeeInReport[]> => (
    eatalianoAxios
        .get(`/employees/time-entries/${restaurantId}/report?from=${from}&to=${to}`)
        .then(response => response.data)
);
